import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'couponType',
})
export class CouponTypePipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        fullSubtraction: '满减',
        discount: '折扣',
        exchange: '商品兑换',
      }[value] || value
    );
  }
}
